import React from 'react';

import * as c from './constants';
import { getToken, getHourToken, TOKEN_KEY, TOKEN_DATE } from '../store/auth';
import * as roles from '../store/roles';
import Swal from 'sweetalert2';

export async function callApi(url, options, callback) {

    try {

        const response = await callFetch(url, options);

        if (response) {
            if (callback) callback(response);
        }

        return response;

    } catch (error) {
        if (error.message) {
            c.TOASTER(error.type, error.message);
        } else {
            c.TOASTER_ERROR(c.NETWORK_ERROR);
        }

    }

}


export async function callFetch(url, options) {
    let optionsAuthorization = {
        method: options.method,
        body: options.body,
        headers: { 'Authorization': 'Bearer ' + getToken(), 'Content-Type': 'application/json' }
    }

    return await fetch(url, optionsAuthorization)
        .then(async (response) => {
            if (response.status === 401) {
                localStorage.removeItem(TOKEN_KEY);
                localStorage.removeItem(TOKEN_DATE);
                document.getElementById('btSair').click();
                c.TOASTER_ERROR(c.AUTH_ERROR);
                return;
            } else if (response.status === 204) {
                return [];
            } else if (response.status === 404) {
                const res = await response.json();
                c.TOASTER_INFO(res.message);
                return [];
            } else if (response.status === 400) {
                const res = await response.json();
                c.TOASTER_INFO(res.message);
                return [];
            } else if (response.status === 500) {
                const res = await response.json();
                console.error(`Error: ${res.title}`, res.detail, res.message);
                throw (res);
            } else if (response.status === 504) {
                return [];
            }
            return await response.json();
        })
        .catch((exception) => {
            if (exception instanceof Error) {
                console.log('Erro JavaScript:', exception.message);
                if (isTokenExpired()) {
                    localStorage.removeItem(TOKEN_KEY);
                    localStorage.removeItem(TOKEN_DATE);

                    Swal.fire({
                        title: 'Sessão expirada',
                        text: 'Sua sessão expirou, por favor faça login novamente.',
                        icon: 'warning',
                        showCancelButton: false,
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#47A789',
                        allowOutsideClick: false
                    }).then((result) => {
                        if (result.isConfirmed) {
                            if (document.getElementById('btnSairSimples') != null) {
                                document.getElementById('btnSairSimples').click();
                            } else if (document.getElementById('btnSairGestor')) {
                                document.getElementById('btnSairGestor').click();
                            } else if (document.getElementById('btSair')) {
                                document.getElementById('btSair').click();
                            }
                        }
                    });
                }
            } else if ('status' in exception) {

                if (exception.status !== 401) {
                    throw exception;
                } else if (exception.status === 401) {
                    localStorage.removeItem(TOKEN_KEY);
                    localStorage.removeItem(TOKEN_DATE);
                    if (document.getElementById('btSair') != null) {
                        document.getElementById('btSair').click();
                    }
                    c.TOASTER_ERROR(c.AUTH_ERROR);
                }

            } else {
                console.log('Falha na chamada da API:', exception);
            }

        });
}



export function login(props, user) {
  return props.actions.auth.login(user)
    .then((resp) => {
      const mustReset = resp?.firstAccess === true;
      if (mustReset) {
        props.history.push({
          pathname: c.TROCA_SENHA,         
          state: { firstAccess: true }
        });
        props.actions.auth.loginFinished?.();
        return; 
      }

      c.TOASTER_SUCCESS("Usuário autenticado com sucesso!");
      let rota = c.PANEL_ROUTE;

      if (resp.papel?.includes('ROLE_EMAIL') || resp.papel?.includes('ROLE_SMS')) {
        rota = c.PANEL_ROUTE;
      } else if (
        resp.papel?.includes('ROLE_ENVIO_MASSA_CARIMBO_TEMPO') ||
        resp.papel?.includes('ROLE_ENVIO_UNICO_CARIMBO_TEMPO')
      ) {
        rota = c.REPORT_ROUTE_CARIMBO;
      } else {
        rota = c.PANEL_ROUTE;
      }

      setTimeout(() => {
        props.history.push(rota);
        props.actions.auth.loginFinished();
      }, 1000);
    })
    .catch((error) => {
      c.TOASTER_ERROR(
        error?.message === 'Failed to fetch'
          ? "Erro na conexão. Por favor, contate o suporte."
          : (error?.message || "Falha de autenticação.")
      );
    });
}

export async function logout(props) {
    props.actions.auth.logout().then((response) => {

        props.history.push(c.DEFAULT_PUBLIC_ROUTE);
        props.actions.auth.logoutFinished();

    });
}

function isTokenExpired() {
    const tokenTimestamp = getHourToken();
    if (!tokenTimestamp) return true;

    const now = Date.now();
    const tokenTimestampDate = new Date(tokenTimestamp.replace(" ", "T") + "Z");
    const tokenTimestampUTC = tokenTimestampDate.getTime();
    const tokenAge = now - tokenTimestampUTC;
    const tokenExpirationTime = 8 * 60 * 60 * 1000; // 8 hours

    return tokenAge > tokenExpirationTime; // Retorna true se o token estiver expirado
}
